import React from "react";
import { HeartPulse, Wind, Thermometer, Droplets, Home, House } from "lucide-react";

export default function SensorIcon({ name, size = 22, className = "" }) {
  const map = {
    heart: HeartPulse,
    nose: Wind,
    thermometer: Thermometer,
    droplets: Droplets,
    "home-thermometer": House,
    "home-droplets": Home,
  };
  const Cmp = map[name] || HeartPulse;
  return <Cmp size={size} strokeWidth={2} className={className} />;
}
